// import anime from "animejs/lib/anime.es.js";
import Highway from "@dogstudio/highway";

import SliderMedia from "../components/sliderMedia";
import SliderBuilding from "../components/sliderBuilding";

var futureObject = {};

class Future extends Highway.Renderer {
  onEnter() {
    futureObject.sliderMedia = new SliderMedia().init();
    futureObject.sliderBuilding = new SliderBuilding().init();
  }
  onEnterCompleted() {}

  onLeave() {}

  onLeaveCompleted() {
    futureObject = {};
  }
}

export default Future;



// WEBPACK FOOTER //
// ./scripts/routes/future.js